


























































import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import { Input, Button } from "ant-design-vue";
import Crumbs from "@/components/Crumbs/index.vue";
import CModal from "@/components/CModal/index.vue";
import Safe from "./components/Safe/index.vue";
import EditMobile from "./components/EditMobile/index.vue";

@Component({
  name: "User",
  components: {
    Crumbs,
    CModal,
    Safe,
    EditMobile,
    AInput: Input,
    AButton: Button
  }
})
export default class User extends Base {
  private created() {
    this._created();
  }

  private save() {
    // this.editMobileVisible = false;
  }

  // private checkParmas() {}

  // // 初始化修改手机弹框
  // private initEditMobileModal() {
  //   this.code = "";
  //   this.uuid = "";
  //   this.phonenumber = "";
  //   this.sendStatus = SendCodeStatus.undo;
  // }
}
